import * as echarts from 'echarts/core'
import { EChartsOption, SeriesOption } from 'echarts'
import ReactECharts from 'echarts-for-react'
import { useMemo } from 'react'
import { merge } from 'lodash'
import echartsTheme from '../../styles/echarts/echarts-theme.json'
import { selectThemeStyle } from '../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../redux/hooks.ts'

interface IdeyaLineChartProps {
  series: SeriesOption
  chartOptions?: EChartsOption
}

export const LineChart: React.FC<IdeyaLineChartProps> = ({
  series,
  chartOptions,
  ...rest
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  series.type = 'line'
  series.labelLine = { show: false }

  const lineChartOption = useMemo<
    EChartsOption & { series: SeriesOption[] }
  >(() => {
    const defaultLineChartOption: EChartsOption & { series: SeriesOption[] } = {
      tooltip: {
        trigger: 'item',
      },
      series: [series],
      xAxis: [
        {
          axisLabel: {
            color: themeStyle.sumText,
          },
        },
      ],
      yAxis: [
        {
          axisLabel: {
            color: themeStyle.sumText,
          },
        },
      ],
    }
    if (chartOptions) {
      merge(defaultLineChartOption, chartOptions)
    }
    return defaultLineChartOption
  }, [series, themeStyle.sumText, chartOptions])

  return (
    <ReactECharts
      echarts={echarts}
      option={lineChartOption}
      theme={echartsTheme.themeName}
      style={{ height: '500px' }}
      {...rest}
    />
  )
}
